import {ReloadButton} from '@flexinet/ui-components';

import {Box} from '@mantine/core';

import {useQueryClient} from '@tanstack/react-query';

import {paymentIntentsKeys} from '../hooks/usePaymentIntentsQuery';

/**
 * FNP-918: reload the payment-intents list.
 *
 * Renamed from `ReloadRecorsButton.tsx` — the misspelling was in the filename
 * and every import of it.
 *
 * ⚠️ This used to call `fetchRecords()` from the list hook. Under the old
 * `useQuery` that invalidated the list; under `useInfiniteQuery` the same name
 * means FETCH THE NEXT PAGE. Wiring Reload to it would have appended a page
 * instead of refreshing — the button would keep loading MORE rows and never
 * re-read the ones on screen. On this module that matters: an operator clicks
 * Reload precisely to see whether a payment intent has moved to `succeeded`.
 *
 * Invalidating the module key is the reload: react-query refetches every loaded
 * page of the active list, so the operator keeps their scroll position and sees
 * fresh data. It also avoids depending on the list hook at all — the old
 * version instantiated a SECOND copy of usePaymentIntents just to reach
 * `fetchRecords`, which fired its own duplicate query on every header render.
 */
export const ReloadRecordsButton = () => {

    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() =>
                    queryClient.invalidateQueries({queryKey: paymentIntentsKeys.all})}
            />
        </Box>
    );
};
